// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"50d18ad3","404":"66072725","433":"4ab1fcb6","513":"590e620b"}[chunkId] + ".chunk.js";
};